export default __webpack_public_path__ + "static/media/seyi-report.9ff2383f.jpeg";